// Captura de fotos: seletor, EXIF, GPS, compressão (720 px, JPEG 0,7) e carimbo de data/hora +
// coordenadas. Port literal do protótipo (index.html:1135–1243): é comportamento do aparelho.

import { pad2, toast } from './util.js';

let fi: HTMLInputElement | null = null, fiCb: any = null;
export function pickPhoto(cb: (d: string) => void) {
  fiCb = cb;
  if (!fi) {
    fi = document.createElement('input'); fi.type = 'file'; fi.accept = 'image/*'; fi.style.display = 'none';
    fi.onchange = function (e: any) { if (e.target.files[0] && fiCb) { compress(e.target.files[0]).then(function (c) { if (c) fiCb(c); (fi as HTMLInputElement).value = ''; }); } };
    document.body.appendChild(fi);
  }
  fi.multiple = false; fi.click();
}
let fiMulti: HTMLInputElement | null = null, fiMultiCb: any = null;
export function pickMultiplePhotos(cb: (arr: string[]) => void) {
  fiMultiCb = cb;
  if (!fiMulti) {
    fiMulti = document.createElement('input'); fiMulti.type = 'file'; fiMulti.accept = 'image/*'; fiMulti.multiple = true; fiMulti.style.display = 'none';
    fiMulti.onchange = function (e: any) {
      if (!e.target.files.length || !fiMultiCb) return;
      const files = Array.prototype.slice.call(e.target.files);
      if (files.length > 1) toast('⏳ Preparando ' + files.length + ' fotos...');
      const promises = files.map(function (f: File) { return compress(f); });
      Promise.all(promises).then(function (results) {
        const valid = results.filter(Boolean) as string[];
        if (valid.length) fiMultiCb(valid);
        if (files.length > 1) toast('📷 ' + valid.length + ' foto(s) adicionada(s)', 'success');
        (fiMulti as HTMLInputElement).value = '';
      });
    };
    document.body.appendChild(fiMulti);
  }
  fiMulti.click();
}

// ── Carimbo de data/hora + coordenadas na foto ──────────────────────────────
let _geoPromise: Promise<any> | null = null, _geoAt = 0;
function getGeo(): Promise<{ lat: number; lng: number } | null> {
  if (_geoPromise && Date.now() - _geoAt < 60000) return _geoPromise;
  _geoAt = Date.now();
  _geoPromise = new Promise(function (res) {
    if (!navigator.geolocation) { res(null); return; }
    let done = false; const t = setTimeout(function () { if (!done) { done = true; res(null); } }, 8000);
    navigator.geolocation.getCurrentPosition(function (p) { if (done) return; done = true; clearTimeout(t); res({ lat: p.coords.latitude, lng: p.coords.longitude }); },
      function () { if (done) return; done = true; clearTimeout(t); res(null); }, { enableHighAccuracy: true, timeout: 7000, maximumAge: 30000 });
  });
  return _geoPromise;
}
// Lê EXIF (GPS + data original) de JPEG; retorna {lat,lng,date} ou null
function readExif(file: File): Promise<any> {
  return new Promise(function (res) {
    const r = new FileReader();
    r.onload = function (e: any) {
      try {
        const v = new DataView(e.target.result);
        if (v.getUint16(0) !== 0xFFD8) { res(null); return; }
        let off = 2; const len = v.byteLength;
        while (off < len - 4) {
          const mk = v.getUint16(off);
          if (mk === 0xFFE1) {
            if (v.getUint32(off + 4) !== 0x45786966) { res(null); return; }
            const t = off + 10, le = v.getUint16(t) === 0x4949;
            const g16 = function (o: number) { return v.getUint16(t + o, le); }, g32 = function (o: number) { return v.getUint32(t + o, le); };
            const ascii = function (o: number, n: number) { let s = ''; for (let i = 0; i < n; i++) { const c = v.getUint8(t + o + i); if (!c) break; s += String.fromCharCode(c); } return s; };
            const ratio = function (o: number) { const d = g32(o + 4); return d ? g32(o) / d : 0; };
            const readIfd = function (o: number) { const n = g16(o), m: any = {}; for (let i = 0; i < n; i++) { const e2 = o + 2 + i * 12; m[g16(e2)] = { type: g16(e2 + 2), count: g32(e2 + 4), val: e2 + 8 }; } return m; };
            const ifd0 = readIfd(g32(4)), out: any = { lat: null, lng: null, date: null };
            if (ifd0[0x8769]) {
              const ex = readIfd(g32(ifd0[0x8769].val));
              const dt = ex[0x9003] || ex[0x9004];
              if (dt) { const s = ascii(g32(dt.val), 19); const m = s.match(/(\d{4}):(\d\d):(\d\d) (\d\d):(\d\d):(\d\d)/); if (m) out.date = new Date(+m[1]!, +m[2]! - 1, +m[3]!, +m[4]!, +m[5]!, +m[6]!); }
            }
            if (ifd0[0x8825]) {
              const gp = readIfd(g32(ifd0[0x8825].val));
              if (gp[1] && gp[2] && gp[3] && gp[4]) {
                const lngRef = String.fromCharCode(v.getUint8(t + gp[3].val));
                const la = g32(gp[2].val), lo = g32(gp[4].val);
                let lat = ratio(la) + ratio(la + 8) / 60 + ratio(la + 16) / 3600, lng = ratio(lo) + ratio(lo + 8) / 60 + ratio(lo + 16) / 3600;
                if (String.fromCharCode(v.getUint8(t + gp[1].val)) === 'S') lat = -lat;
                if (lngRef === 'W') lng = -lng;
                if (isFinite(lat) && isFinite(lng) && (lat || lng)) { out.lat = lat; out.lng = lng; }
              }
            }
            res(out); return;
          }
          if ((mk & 0xFF00) !== 0xFF00) { break; }
          off += 2 + v.getUint16(off + 2);
        }
      } catch (err) { /* EXIF ilegível: segue sem */ }
      res(null);
    };
    r.onerror = function () { res(null); };
    r.readAsArrayBuffer(file.slice(0, 262144));
  });
}
function fmtStampDate(d: Date) { return pad2(d.getDate()) + '/' + pad2(d.getMonth() + 1) + '/' + d.getFullYear() + ' ' + pad2(d.getHours()) + ':' + pad2(d.getMinutes()); }
function stampCanvas(c: HTMLCanvasElement, date: Date, geo: any) {
  const ctx = c.getContext('2d') as CanvasRenderingContext2D, w = c.width, h = c.height;
  const fs = Math.max(14, Math.round(Math.min(w, h) * 0.045)), pad = Math.round(fs * 0.55), gap = Math.round(fs * 0.3);
  const bh = fs * 2 + gap + pad * 2;
  ctx.fillStyle = 'rgba(0,0,0,.72)'; ctx.fillRect(0, h - bh, w, bh);
  ctx.fillStyle = '#fff'; ctx.textBaseline = 'top';
  ctx.font = '700 ' + fs + 'px Arial,Helvetica,sans-serif';
  ctx.fillText(fmtStampDate(date), pad, h - bh + pad);
  ctx.font = '600 ' + fs + 'px Arial,Helvetica,sans-serif';
  ctx.fillStyle = geo ? '#fff' : '#fcd34d';
  ctx.fillText(geo ? ('Lat ' + geo.lat.toFixed(6) + '  Lng ' + geo.lng.toFixed(6)) : 'Localização indisponível', pad, h - bh + pad + fs + gap);
}
let _geoWarned = false;
export function compress(file: File): Promise<string | null> {
  return new Promise(function (res) {
    Promise.all([readExif(file), getGeo()]).then(function (rs) {
      const ex = rs[0], cur = rs[1];
      const date = (ex && ex.date) || (file.lastModified ? new Date(file.lastModified) : new Date());
      const geo = (ex && ex.lat !== null && ex.lat !== undefined) ? { lat: ex.lat, lng: ex.lng } : cur;
      if (!geo && !_geoWarned) { _geoWarned = true; try { toast('📍 Ative a localização do navegador para gravar as coordenadas nas fotos', 'error'); } catch (e) { /* sem toast */ } }
      const r = new FileReader(); r.onload = function (e: any) { const img = new Image(); img.onload = function () { const M = 720, rat = Math.min(M / img.width, M / img.height, 1); const c = document.createElement('canvas'); c.width = Math.round(img.width * rat); c.height = Math.round(img.height * rat); (c.getContext('2d') as CanvasRenderingContext2D).drawImage(img, 0, 0, c.width, c.height); try { stampCanvas(c, date, geo); } catch (err) { /* sem carimbo */ } res(c.toDataURL('image/jpeg', .7)); }; img.onerror = function () { res(null); }; img.src = e.target.result; }; r.readAsDataURL(file);
    });
  });
}

/** data URL → Blob (para o multipart e para abrir anexos). */
export function dataUrlParaBlob(d: string): Blob {
  const p = String(d).split(',');
  const mime = ((p[0] || '').match(/:(.*?);/) || [])[1] || 'application/octet-stream';
  const bin = atob(p[1] || '');
  let n = bin.length; const u = new Uint8Array(n);
  while (n--) u[n] = bin.charCodeAt(n);
  return new Blob([u], { type: mime });
}
